var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Toast from "@lonelyplanet/dotcom-core/dist/components/toast/globalToastFromCookie";
import Login from "@lonelyplanet/dotcom-core/dist/components/login";
import DataLayer from "@lonelyplanet/dotcom-core/dist/containers/dataLayer";
import { poisRoutes } from "@lonelyplanet/dotcom-routing/dist/details/routes";
import { Helmet } from "@lonelyplanet/travel-agent/dist/helmet";
import * as React from "react";
import { Provider } from "react-redux";
import { Route } from "react-router-dom";
import Bookmarks from "../modules/bookmarks";
import Pois from "../modules/pois";
import configurePoiStore from "../modules/pois/store/configureStore";
import Profile from "../modules/profile";
import Search from "../modules/search";
import { AppProviders } from "./appProviders";
import Asset from "./components/asset";
import { bookmarkRoutes, profileRoutes, searchRoutes } from "./constants";
import { analytics, ApplicationNames, DataLayerInitializationData, } from "@lonelyplanet/lp-analytics";
var poiStore = configurePoiStore();
if (typeof window !== "undefined") {
    window.$$store = poiStore;
}
var App = /** @class */ (function (_super) {
    __extends(App, _super);
    function App() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    App.prototype.render = function () {
        var _a;
        var props = this.props;
        var _b = props.features, features = _b === void 0 ? {} : _b, _c = props.poi, poi = _c === void 0 ? {} : _c;
        return (React.createElement(AppProviders, null,
            React.createElement("div", null,
                React.createElement(Helmet, { titleTemplate: "%s - Lonely Planet", defaultTitle: "Lonely Planet" }),
                React.createElement(DataLayer, { data: {
                        cd22_ApplicationName: "dotcom-web",
                        cd24_LoginState: null,
                    } }),
                React.createElement(DataLayerInitializationData, { data: (_a = {},
                        _a[analytics.applicationName] = ApplicationNames.dotcomWeb,
                        _a[analytics.dispatchVariant] = features,
                        _a) }),
                React.createElement(Route, { path: bookmarkRoutes.show, component: Bookmarks }),
                React.createElement(Route, { path: searchRoutes.show, render: function () { return React.createElement(Search, __assign({}, props.search)); } }),
                React.createElement(Route, { exact: true, path: profileRoutes.show, component: Profile }),
                React.createElement(Route, { path: bookmarkRoutes.show, component: Bookmarks }),
                React.createElement(Route, { exact: true, path: poisRoutes.detail, render: function poiRender(route) {
                        return (React.createElement(Provider, { store: poiStore },
                            React.createElement(Pois, __assign({}, props, { match: route.match }))));
                    } }),
                React.createElement(Login, null),
                React.createElement(Toast, null),
                React.createElement(Asset, { src: "app.js" }))));
    };
    return App;
}(React.Component));
export default App;
// import createHistory from "history/createBrowserHistory";
// export default ({
//   message
// }) => (
// <Router
//   history={createHistory()}
// >
//   <Route match="/" render={() => (
//     <AsyncPois
//       message="hell effin yea oh hai!!"
//     />)}
//   />
// </Router>
// );



//////////////////
// WEBPACK FOOTER
// ./app/shared/app.tsx
// module id = FcFf
// module chunks = 2